import { defineStore } from 'pinia';
import ApiService from '@/services/ApiService';

export const useTagStore = defineStore('tag', {
  state () {
    return {
      tagData: [],
      selectedTab: 0,
      groupData: [
        {
          groupName: 'uncategorized',
          groupId: null,
        },
      ],
      includedTags: [],
    };
  },
  getters: {
    getTagTitles () {
      return this.tagTitles;
    },
    getTagData () {
      return this.tagData;
    },
    getSelectedTab () {
      return this.selectedTab;
    },
  },
  actions: {
    async fetchTags () {
      return ApiService.fetchTags()
        .then((response) => {
          this.tagData = response.data;
        })
        .catch((error) => {
          console.log('Error: ' + JSON.stringify(error));
          throw error;
        });
    },
    getTagsById (ids) {
      if (ids === undefined) { return []; }
      let arr = [];
      this.tagData.forEach((tag) => {
        if (ids.includes(tag.tagId)) {
          arr.push(tag);
        }
      });
      return arr.sort((a, b) => a.tag.localeCompare(b.tag));
    },

    getTagsInSelectedGroup () {
      if (this.groupData.length === 0) { return; }
      let gid;
      if (this.groupData[this.selectedTab] === undefined) {
        this.selectedTab = 0;
        gid = this.groupData[this.selectedTab].groupId;
      } else {
        gid = this.groupData[this.selectedTab].groupId;
      }
      if (gid === undefined) { return; }
      // todo: the - 0 below is a hack since group ids in the tags and groups don't align
      let tags = this.tagData.filter((t) => t.groupId === gid);
      return tags;
    },
    setSelectedTab (num) {
      this.selectedTab = num;
    },
    async createTag (obj) {
      // todo: add API call to add tag to a group
      this.tagData.push(obj);
      return ApiService.createTag(obj)
      .then(() => {
        this.fetchTags();
      })
      .catch((error) => {
        console.log('Error: ' + JSON.stringify(error));
        throw error;
      });
    },
    async updateTag (obj) {
      try {
        await ApiService.createTag(obj);
        this.fetchTags();
      } catch {
        console.log(error);
      }
    },
    // removing tags
    async removeTag (tagId) {
      return ApiService.removeTag(tagId).then(() => {
        this.fetchTags();
      }).catch((error) => {
        console.log('Error: ' + JSON.stringify(error));
        throw error;
      });
    },
    async fetchGroups () {
      return ApiService.fetchGroups()
        .then((response) => {
          this.groupData = [];
          this.groupData.push(...response.data);
        })
        .catch((error) => {
          console.log('Error: ' + JSON.stringify(error));
          throw error;
        });
    },
    async deleteGroup (tagId) {
      return await ApiService.removeGroup(tagId)
        .then(() => {
          this.fetchGroups();
        })
        .catch((error) => {
          throw error;
        });
    },
    async updateGroup (group) {
      await ApiService.updateGroup(group)
        .then(() => {
          this.fetchGroups();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getGroupById (group) {
      let groupItem;
      this.groupData.forEach((element) => {
        if (element.groupId === group.groupId) {
          groupItem = { groupId: element.groupId, tag: element.groupName, color: element.color };
        }
      });
      return groupItem;
    },
  },
});
